import React from "react";

interface props extends React.HTMLProps<SVGSVGElement | HTMLImageElement> { }

const CurrencyIcon = (props: props) => {
    if (props.src) return <img src={props.src} alt={"currency"} />;
    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                color: "#1a2c38",
            }}
        >
            $
        </div>
    );
};

export default CurrencyIcon;
